import { DeleteNotificationContactsObservable } from "./NotificationContactsProcess"
import useNotificationAction from "./useNotificationAction"

function useNotificationContactsDelete(callback?: (result?: string) => void | Promise<void>) {
  const [processing, deleteContacts] = useNotificationAction<string>({
    actionObservable: DeleteNotificationContactsObservable,
    callback,
  })

  return { deletingContacts: processing, deleteContacts }
}

export default useNotificationContactsDelete
